import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSWildRiceProduct from 'models/BSWildRiceProduct'
import BSWildRicePackage from './BSWildRicePackage'

const productOptions = {
  packagingInfo: <BSWildRicePackage />,
  productTitle: 'Brand Specific Wild Rice',
  model: BSWildRiceProduct,
  validCategories: ['16'],
  validSubCategories: ['015'],
  brandSpecific: true,
}

const BSWildRice = () => <ProductForm product={productOptions} />

export default BSWildRice
